import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Stack,
  Button,
  IconButton,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Sidebar from "../Sidebar/Sidebar";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import AudioFileRoundedIcon from "@mui/icons-material/AudioFileRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate } from "react-router-dom";

export default function AddRecording() {
  const theme = useTheme();
  const isMobile = useMediaQuery( theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const handleFileUpload = (e) => {
    const uploadedFiles = Array.from(
      e.target.files
    );

    setFiles((prev) => [
      ...prev,
      ...uploadedFiles,
    ]);
  };

  const removeFile = (index) => {const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
  };

  const handleSubmit = () => {
    console.log("Uploaded Files:", files);
    // API CALL 
  };

  return (
    <Box
      sx={{
        display: "flex",
        background: "#F8FAFC",
        minHeight: "100vh",
      }}
    >
      <Sidebar
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
        }}
      >
        <Box sx={{p: { xs: 2,  sm: 3, md: 4,},}}>
          {isMobile && (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
              >
                <IconButton
                  onClick={() =>
                    setMobileOpen(true)
                  }
                >
                  <MenuRoundedIcon />
                </IconButton>

                <Typography
                  variant="h6"
                  fontWeight={800}
                >
                  Add Recording
                </Typography>
              </Stack>
            </Stack>
          )}

          {/* DESKTOP HEADER */}
          {!isMobile && (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              mb={4}
            >
              <Box>
                <Typography
                  variant="h4"
                  fontWeight={800}
                >
                  Add Recording
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    mt: 0.5,
                    color: "#64748B",
                  }}
                >
                  Upload single or bulk call
                  recordings
                </Typography>
              </Box>

              <Button
                variant="outlined"
                startIcon={
                  <ArrowBackRoundedIcon />
                }
                onClick={() =>
                  navigate("/recordings")
                }
                sx={{
                  borderRadius: "12px",
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Back
              </Button>
            </Stack>
          )}

          <Paper
            sx={{
              borderRadius: 5,
              p: {
                xs: 2,
                sm: 3,
                md: 4,
              },
              boxShadow:
                "0 8px 30px rgba(0,0,0,0.05)",
            }}
          >
            {/* FILE UPLOAD */}
            <Typography
              variant="h6"
              fontWeight={700}
              mb={2}
            >
              Upload Recordings
            </Typography>

            <Paper
              variant="outlined"
              sx={{
                borderRadius: 4,
                borderStyle: "dashed",
                borderWidth: 2,
                borderColor: "#CBD5E1",
                p: {
                  xs: 3,
                  md: 5,
                },
                textAlign: "center",
                background: "#F8FAFC",
              }}
            >
              <CloudUploadRoundedIcon
                sx={{
                  fontSize: 60,
                  color: "#2563EB",
                  mb: 2,
                }}
              />

              <Typography
                variant="h6"
                fontWeight={700}
                mb={1}
              >
                Upload Audio Files
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#64748B",
                  mb: 3,
                }}
              >
                Drag & drop files or browse
                from device
                <br />
                Supports single & bulk upload
              </Typography>

              <Button
                variant="contained"
                component="label"
                startIcon={
                  <UploadFileRoundedIcon />
                }
                sx={{
                  borderRadius: "12px",
                  px: 3,
                  py: 1.2,
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "none",
                  background:
                    "linear-gradient(135deg,#2563EB 0%,#06B6D4 100%)",

                  "&:hover": {
                    background:
                      "linear-gradient(135deg,#1D4ED8 0%,#0891B2 100%)",
                  },
                }}
              >
                Choose Files

                <input
                  type="file"
                  hidden
                  multiple
                  accept="audio/*"
                  onChange={
                    handleFileUpload
                  }
                />
              </Button>

              <Typography
                variant="caption"
                display="block"
                mt={2}
                color="text.secondary"
              >
                Accepted formats: MP3, WAV,
                M4A
              </Typography>
            </Paper>

            {/* FILE LIST */}
            {files.length > 0 && (
              <Box mt={4}>
                <Typography
                  variant="h6"
                  fontWeight={700}
                  mb={2}
                >
                  Selected Files (
                  {files.length})
                </Typography>

                <Stack spacing={2}>
                  {files.map(
                    (file, index) => (
                      <Paper
                        key={index}
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          display: "flex",
                          alignItems:
                            "center",
                          justifyContent:
                            "space-between",
                          boxShadow:
                            "0 4px 12px rgba(0,0,0,0.04)",
                        }}
                      >
                        <Stack
                          direction="row"
                          spacing={2}
                          alignItems="center"
                        >
                          <Box
                            sx={{
                              width: 50,
                              height: 50,
                              borderRadius:
                                "14px",
                              background:
                                "rgba(37,99,235,0.1)",
                              display: "flex",
                              alignItems:
                                "center",
                              justifyContent:
                                "center",
                            }}
                          >
                            <AudioFileRoundedIcon
                              sx={{
                                color:
                                  "#2563EB",
                              }}
                            />
                          </Box>

                          <Box>
                            <Typography
                              fontWeight={
                                600
                              }
                            >
                              {file.name}
                            </Typography>

                            <Chip
                              size="small"
                              label={`${(
                                file.size /
                                1024 /
                                1024
                              ).toFixed(
                                2
                              )} MB`}
                              sx={{
                                mt: 0.5,
                              }}
                            />
                          </Box>
                        </Stack>

                        <IconButton
                          color="error"
                          onClick={() =>
                            removeFile(
                              index
                            )
                          }
                        >
                          <DeleteRoundedIcon />
                        </IconButton>
                      </Paper>
                    )
                  )}
                </Stack>
              </Box>
            )}

            {/* ACTION BUTTONS */}
            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              spacing={2}
              justifyContent="flex-end"
              mt={5}
            >
              <Button
                variant="outlined"
                onClick={() =>
                  navigate("/recordings")
                }
                sx={{
                  borderRadius: "12px",
                  px: 4,
                  py: 1.2,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={files.length === 0}
                sx={{
                  borderRadius: "12px",
                  px: 4,
                  py: 1.2,
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "none",
                  background:
                    "linear-gradient(135deg,#2563EB 0%,#06B6D4 100%)",

                  "&:hover": {
                    background:
                      "linear-gradient(135deg,#1D4ED8 0%,#0891B2 100%)",
                  },
                }}
              >
                Upload Recording
              </Button>
            </Stack>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}